import { useContext } from 'react';
import { EventContext } from './EventContext';

export function useEventDispatch() {
  const { dispatchEvent } = useContext(EventContext);

  return dispatchEvent;
}
